__turbopack_context__.v({
  "mentions": "HonorableMentions-module__ZzPUeq__mentions",
  "section": "HonorableMentions-module__ZzPUeq__section",
});
